<template>
<div class="columns">
    <div class="column">
        <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                    Details
                </p>
            </header>
            <div class="card-content">
                <div class="content">
                    <p>
                        <strong>{{ $root.event.name }}</strong>
                    </p>
                    <p>
                        <b v-if="$root.event.start == $root.event.end">
                            {{$moment($root.event.start, 'YYYY-MM-DD').format('dddd, D. MMM YY')}}
                        </b>
                        <b v-else>
                            {{$moment($root.event.start, 'YYYY-MM-DD').format('ddd D. MMM YY')}} - {{$moment($root.event.end, 'YYYY-MM-DD').format('ddd D. MMM YY')}}
                        </b>
                    </p>
                    <p>
                        <a @click="() => {$root.env.view.activeTab = 1;$root.env.view.tabArrangement = 3}">{{$root.event.locations ? $root.event.locations.length : '0'}} Locations</a>
                    </p>
                    <p>
                        <a @click="() => {$root.env.view.activeTab = 1;$root.env.view.tabArrangement = 4}">{{$root.event.workshops ? $root.event.workshops.length : '0'}} Workshops</a>
                    </p>
                    <p>
                        <a @click="() => {$root.env.view.activeTab = 1;$root.env.view.tabArrangement = 5}">{{$root.event.transfers ? $root.event.transfers.length : '0'}} Transfers</a>
                    </p>
                    <p>
                        <a @click="() => {$root.env.view.activeTab = 1;$root.env.view.tabArrangement = 6}">{{$root.event.accommodations ? $root.event.accommodations.length : '0'}} Unterbringungen</a>
                    </p>
                    <p>
                        <a @click="() => {$root.env.view.activeTab = 2}">{{$root.event.communications ? $root.event.communications.length : '0'}} E-Mails erstellt</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="column">
        <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                    Rückmeldungen
                </p>
            </header>
            <div class="card-content">
                <div class="content">
                    <p>
                        <strong>Anzahl gesamt: </strong> {{$root.users ? $root.users.length : '0'}}
                    </p>
                    <p v-if="typeof $root.event.stats !== 'undefined'">
                        <strong>Anzahl Rückmeldungen: </strong> {{typeof $root.event.stats.count !== 'undefined' ? $root.event.stats.count : '0'}}
                    </p>
                    <p v-if="typeof $root.event.stats !== 'undefined'">
                        <strong>Anzahl Anmeldungen: </strong> {{typeof $root.event.stats._attending !== 'undefined' ? $root.event.stats._attending.length : '0'}}
                    </p>
                    <p v-if="typeof $root.event.stats !== 'undefined'">
                        <strong>Anzahl Abmeldungen: </strong> {{typeof $root.event.stats._notAttending !== 'undefined' ? $root.event.stats._notAttending.length : '0'}}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="column">
        <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                    Anmeldungen Workshops
                </p>
            </header>
            <div class="card-content">
                <div class="content">
                    <p v-for="r in this.$root.event.workshops" style="margin-bottom: 0;font-size: .8rem;">
                        {{r.name}}: <strong>{{$root.event.stats['workshop_'+r.id] ? $root.event.stats['workshop_'+r.id].length : '0'}}</strong>
                    </p>
                </div>
            </div>
        </div>
        <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                    Anmeldungen Transfers
                </p>
            </header>
            <div class="card-content">
                 <div class="content">
                    <p v-for="r in this.$root.event.transfers" style="margin-bottom: 0;font-size: .8rem;">
                        {{r.name}}: <strong>{{$root.event.stats['transfer_'+r.id] ? $root.event.stats['transfer_'+r.id].length : '0'}}</strong>
                    </p>
                </div>
            </div>
        </div>
        <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                    Anmeldungen Unterbringungen
                </p>
            </header>
            <div class="card-content">
                 <div class="content">
                    <p v-for="r in this.$root.event.accommodations" style="margin-bottom: 0;font-size: .8rem;">
                        {{r.name}}: <strong>{{$root.event.stats['accommodation_'+r.id] ? $root.event.stats['accommodation_'+r.id].length : '0'}}</strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'Dashboard',
    props: {

    },
    data() {
        return {

        }
    },
    methods: {
        update(id = this.$route.params.id) {
            //this.$root.getUsers(id)
            return true
        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed
        this.update()
    },
    computed: {

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
